import { Injectable } from '@angular/core';
import * as Rx from 'rxjs';
import * as io from 'socket.io-client';
import { environment } from '../../../environments/environment';
import { CommonService } from '../../shared/common.service';
import { Subject, Observable, BehaviorSubject } from 'rxjs';
@Injectable({ providedIn: 'root' })
export class ChatService {
  observable: Observable<any>;
  socket: any;
  userDetail:any;
  userId:any;
  isInitialConnectionDone: Boolean = false;


  constructor(public commonService:CommonService) {
    this.commonService.loginStatusSub.subscribe(status => {
      if (status == "loggedIn"){
        this.userDetail=  this.commonService.getUser();
        this.socket = io(environment.backendApiURL + '?userId=' + this.userDetail.userId);
        this.socket.on('connect', () => this.isInitialConnectionDone = true);
      }
  
      if (status == "loggedOut") {
        this.disconnectConnection();
        this.isInitialConnectionDone = false;
      }
    }) 
   }
   
  createConnectionIfBroken() {
    if (this.isInitialConnectionDone && !this.socket.connected && this.userDetail.userId) {
    this.socket.connect();
    }
  }



  // This one is for send data from angular to node 
  pushData(e) {
    // this.socket.emit('sendMessage', e);
    this.socket.emit("sendMessage",e, (response) => {
      if(response){
        this.sendMessageEmit(response.data)
      }

    });
  }
  pushEditData(e){
    this.socket.emit("isEditMessage",e, (response) => {
      if(response){
        this.sendMessageEmit(response.data)
      }

    });
  }
  pushreply(e) {
    // this.socket.emit('sendReply', e);
    this.socket.emit("sendReply",e, (response) => {
      if(response){
        this.sendReplyMessageEmit(response.data)
      }
    });
  }
  pushreplyedit(e) {
    // this.socket.emit('sendReply', e);
    this.socket.emit("isEditMessageReply",e, (response) => {
      if(response){
        this.sendReplyMessageEmit(response.data)
      }
    });
  }
  userIsTyping(e) {
    this.socket.emit('isTyping', e);
  }
  isCircleChatMessageSeen(e) {
    this.socket.emit('isSeen', e);
  }

  isCircleChatThreadMessageSeen(e) {
    this.socket.emit('isReplySeen', e);
  }


  userTypingStopped(e) {
    this.socket.emit('isTypingStop', e);
  }

  getMessages() {
    let observable = new Observable(observer => {
      const handler = (data) => observer.next(data);
      this.socket.on('sendMessage', handler);
      return () => this.socket.off('sendMessage', handler);
    })
    return observable;
  }
  getReply() {
    let observable = new Observable(observer => {
      const handler = (data) => observer.next(data);
      this.socket.on('sendReply', handler);
      return () => this.socket.off('sendReply', handler);
    })
    return observable;
  }

  isTyping() {
    let observable = new Observable(observer => {
      const handler = (data) => observer.next(data);
      this.socket.on('isTyping', handler);
      return () => this.socket.off('isTyping', handler);
    })
    return observable;
  }
  isTypingStop() {
    let observable = new Observable(observer => {
      const handler = (data) => observer.next(data);
      this.socket.on('isTypingStop', handler);
      return () => this.socket.off('isTypingStop', handler);
    })
    return observable;
  }

  getCircleUnreadCountUpdate() {
    let observable = new Observable(observer => {
      const handler = (data) => observer.next(data);
      this.socket.on('circleUnreadCountUpdate', handler);
      return () => this.socket.off('circleUnreadCountUpdate', handler);
    })
    return observable;
  }

  getSocketConnected() {
    let observable = new Observable(observer => {
      const handler = () => observer.next(true);
      this.socket.on('connect', handler);
      return () => this.socket.off('connect', handler);
    })
    return observable;
  }

  getGroupUnreadCountUpdate() {
    let observable = new Observable(observer => {
      const handler = (data) => observer.next(data);
      this.socket.on('groupUnreadCountUpdate', handler);
      return () => this.socket.off('groupUnreadCountUpdate', handler);
    })
    return observable;
  }

gotMessageEmit: Rx.Subject<any> = new Subject();
alertGotMessageEmit$ = this.gotMessageEmit.asObservable();
sendMessageEmit(data: any) {
  let obj = {data:data}
  this.gotMessageEmit.next(obj);
}
getMessageEmit(): Observable<any> {
  return this.alertGotMessageEmit$;
}


gotMessageReplyEmit: Rx.Subject<any> = new Subject();
alertGotMessageReplyEmit$ = this.gotMessageReplyEmit.asObservable();
sendReplyMessageEmit(data: any) {
  let obj = {data:data}
  this.gotMessageReplyEmit.next(obj);
}


getMessageReplyEmit(): Observable<any> {
  return this.alertGotMessageReplyEmit$;
}
disconnectConnection() {
  if (this.socket && this.socket.connected) this.socket.disconnect();
}

studyToChat(e) {
  this.socket.emit('joinOrLeaveCircleRooms', e);
}
}